import UserToUser from "../pages/Transfer/UserToUser";

//need to change url and key
export const APIROUTE = {
    baseUrl: "https://accountingreport909api-33504700051.asia-southeast1.run.app/api/v1/",
   //  baseUrl: 'http://localhost:8080/api/v1/',
    login: 'admin/login',
    admin: 'admin',
    allInfo: 'dashboard/all-info',
    userInfo: 'dashboard/user-info',
    loginUser: 'agent/login-user/agents',
    gameType: 'game-type',
    sharePercent: 'share-percent',
    transactionTypes: 'transaction-types',
    transaction: 'transaction', //agent to user
    transactionUtoA: 'utoa-transaction', //user to agent
    UserToUser: 'utou-transaction',
    userfundbytype: 'user-fund-transfer-types',
    income: 'income',
    expense: 'expense',
    agent: 'agent',
    winloss: 'win-loss',
    winLossTotal: 'win-loss/total-winloss',
    result: 'agent-results',
    profitShare: 'profit-share/user',
    winLossAllGameType: 'profit-share',
    getSharePercentByGameType: 'share-percent/gametype',
    userfundhistory: 'transaction/get-all-transaction-history',
}

export const STORAGE_KEYS = {
    TOKEN: 'TOKEN',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    USER: 'USER',
    LOGIN_CREDENTIALS: 'LOGIN_CREDENTIAL',
    REMEMBER_ME: 'REMEMBER_ME',
    CREDENTIAL: 'CREDENTIAL',
};

export const PROJECT_KEYS = {
    secretKey: 'ybGaTxi0sYyCZkq/TLeHOlMAZCB30m+Kg4K3DVxVqMzc4vrFKpqaD3FxGtPIr1G9',
    mapKey: 'AIzaSyCfeYDhXa9KAog_cUCtJtSnykn6xeMLxsU',
}
